export const SAD_EMOJI = '😔';
export const CONFUSED_EMOJI = '😵';
export const THUMBS_EMOJI = '👍';
export const UPSIDE_DOWN_EMOJI = '🙃';
export const DOWNCAST_EMOJI = '😓';
export const THINKING_EMOJI = '🤔';